import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "b-edit-assigned__member" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "b-consult-card__worker-arrow" }
const _hoisted_4 = {
  key: 1,
  class: "h-font-14 h-fw-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderFormEvent = _resolveComponent("HeaderFormEvent")!
  const _component_FwInput = _resolveComponent("FwInput")!
  const _component_WorkerAvatar = _resolveComponent("WorkerAvatar")!
  const _component_FwIcon = _resolveComponent("FwIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderFormEvent, {
      confirmButton: `BUTTON.SAVE`,
      title: _ctx.$t(`EVENT.FORM.LABEL.REASSIGNED.TO`),
      onPreviousComponent: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit("backButton"))),
      onConfirmEvent: _ctx.confirmEvent
    }, null, 8, ["title", "onConfirmEvent"]),
    _createVNode(_component_FwInput, {
      value: _ctx.searchText,
      placeholder: _ctx.$t(`EVENT.FORM.PLACEHOLDER.SEARCH`),
      iconRight: "loupe",
      iconSize: "15",
      inputStyle: "search",
      type: "search",
      onInput: _cache[1] || (_cache[1] = value => _ctx.searchText = value)
    }, null, 8, ["value", "placeholder"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preparedUsersCards, (user) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "b-edit-assigned__member--card h-flex h-flex-space-between h-flex-center h-pointer",
        onClick: ($event: any) => (_ctx.chooseMemberId(user.id))
      }, [
        user
          ? (_openBlock(), _createBlock(_component_WorkerAvatar, {
              key: 0,
              class: "h-mv-15",
              worker: user,
              advisorLabel: _ctx.advisorLabel,
              size: "small",
              align: "right"
            }, null, 8, ["worker", "advisorLabel"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          (user.id === _ctx.memberId)
            ? (_openBlock(), _createBlock(_component_FwIcon, {
                key: 0,
                class: "h-mh-5",
                icon: "circle-arrow-bottom",
                size: "20",
                color: "#27dbbd"
              }))
            : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t('EVENT.FORM.LABEL.SELECT')), 1))
        ])
      ], 8, _hoisted_2))
    }), 256))
  ]))
}